export default "__VITE_ASSET__DNYTFKcs__"